import { httpClient } from "../../../lib/http-client/http-client";
import { API_ROUTES } from "../../constants/api.routes";
import { ICreateWorkspaceRequest, ISwitchWorkspaceRequest } from "../interface/requests/IWorkspace";
import { IWorkspaceListResponse, ICreateWorkspaceResponse, ISwitchWorkspaceResponse, IUpdateWorkspaceResponse } from "../interface/responses/IWorkspaceResponses";
import { IBaseResponse } from "../interface/responses/IBaseResponse";

class WorkspaceService {
  constructor() {}

  public async getUserWorkspaces(): Promise<IBaseResponse<IWorkspaceListResponse>> {
    const response = await httpClient.get<IWorkspaceListResponse>(API_ROUTES.Workspaces.List);
    return response;
  }

  public async createWorkspace(data: ICreateWorkspaceRequest): Promise<IBaseResponse<ICreateWorkspaceResponse>> {
    const response = await httpClient.post<ICreateWorkspaceResponse>(API_ROUTES.Workspaces.Create, data);
    return response;
  }

  public async switchWorkspace(data: ISwitchWorkspaceRequest): Promise<IBaseResponse<ISwitchWorkspaceResponse>> {
    const response = await httpClient.post<ISwitchWorkspaceResponse>(API_ROUTES.Workspaces.Switch, data);
    return response;
  }

  public async updateWorkspace(companyId: string, data: ICreateWorkspaceRequest): Promise<IBaseResponse<IUpdateWorkspaceResponse>> {
    const response = await httpClient.put<IUpdateWorkspaceResponse>(API_ROUTES.Workspaces.Update(companyId), data);
    return response;
  }
}

const workspaceService = new WorkspaceService();
export default workspaceService;